<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  @switch (column.key) {
    @case (getColumn('featureFileUrl')) {
      @if (isNotNil(model.featureFileUrl)) {
        <app-image-thumbnail>
          <img
            [ngSrc]="model.featureFileUrl"
            [fill]="true"
            [alt]="model.featureFileAlt"
            class="object-contain" />
        </app-image-thumbnail>
      } @else {
        <app-image-thumbnail-unsupported />
      }
    }

    @case (getColumn('name')) {
      <div class="break-words whitespace-normal">
        {{ model.name }}
      </div>
    }

    @case (getColumn('cosmeticBrandName')) {
      @if (isNotNil(model.cosmeticBrandName)) {
        <div class="break-words whitespace-normal">
          {{ model.cosmeticBrandName }}
        </div>
      } @else {
        <app-no-data />
      }
    }

    @case (getColumn('amount')) {
      @if (isNotNil(model.amount)) {
        {{ model.amount }}
      } @else {
        <app-no-data />
      }
    }

    @case (getColumn('availableQuantity')) {
      @if (isNotNil(model.availableQuantity)) {
        {{ model.availableQuantity }}
      } @else {
        <app-no-data />
      }
    }

    @default {
      <app-table-body-no-reference-cell [columnKey]="column.key" />
    }
  }
</ng-template>
